import { useCallback } from 'react';
import * as ApiModels from '@typings/api-models';
import * as format from '@format';
import Button from '../DesignLibrary/Button';
import CalendarCheck from '../Icons/CalendarCheck';
import s from './UserWorkflowInfo.module.scss';

type Props = {
  booking: Pick<ApiModels.Booking, 'startAt' | 'endAt' | 'meetingLink'> | null;
  creator: Pick<ApiModels.Creator, 'timezone'> | null;
};

const UserWorkflowBooking: React.FC<Props> = ({ booking, creator }) => {
  const handleClick: NonNullable<Parameters<typeof Button>[0]['onClick']> = useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();
    if (booking?.meetingLink) {
      window.open(booking.meetingLink, '_blank');
    }
  }, []);

  if (
    !booking
    || !booking.startAt
    || !booking?.endAt
    || !creator?.timezone
  ) {
    return null;
  }

  return (
    <span className={s.booking}>
      {format.datetimeLocalTZ.humanReadable({ datetime: booking.startAt, timezone: creator.timezone })}
      {booking.meetingLink
        ? (
          <Button
            size="xs"
            variant='secondary'
            onClick={handleClick}
          >
            <CalendarCheck size={12} weight='fill' />
            Join
          </Button>
        )
        : null
      }
    </span>
  );
};

export default UserWorkflowBooking;
